import { render, staticRenderFns } from "./ClientSEO.vue?vue&type=template&id=2618c158"
import script from "./ClientSEO.vue?vue&type=script&lang=js"
export * from "./ClientSEO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports